const Layout = ({ children }) => {
  //   const [menu, setMenu] = useState(false);

  return (
    <div className="w-screen">
      {/* <NavBar menu={menu} setMenu={setMenu} /> */}
      <div className="pt-10 md:pt-16">{children}</div>
      {/* <div className={menu === true ? "hidden" : null}>
        <Footer />
      </div> */}
    </div>
  );
};

export default Layout;
